<template>
  <div class="nodeMap">
    <div class="warpper">
      <div class="node_map_area">
        <div v-if="pageSize" class="mobile-title">
          <button class="tab active" type="button" v-html="$t('node_map.sidebarTitle')"></button>
        </div>

        <div v-if="!pageSize" class="map_siderbar">
          <button class="tab active" type="button" v-html="$t('node_map.sidebarTitle')"></button>
          <h2></h2>
          <NodeStatus type="1" :text="$t('node_map.OffLine')" :value="node_Offline" />
          <NodeStatus type="2" :text="$t('node_map.Synchronizing')" :value="node_Synchronizing" />
          <NodeStatus type="3" :text="$t('node_map.Idle')" :value="node_Idle" />
          <NodeStatus type="4" :text="$t('node_map.LocalConsensus')" :value="node_LocalConsensus" />
          <NodeStatus type="5" :text="$t('node_map.GlobalConsensus')" :value="node_GlobalConsensus" />
          <NodeStatus type="6" :text="$t('node_map.Success')" :value="node_Success" />
          <NodeStatus type="7" :text="$t('node_map.Exception')" :value="node_Exception" />
          <NodeStatus type="8" :text="$t('node_map.Suspect')" :value="node_Suspect" />
        </div>

        <div class="map_newNodeNum">
          {{$t('node_map.NewNodeNumText')}}
          <span class="map_newNodeNum-text">{{node_new}}</span>
        </div>

        <div class="zoom_btn-area">
          <button @click="clickMapZoom()" class="zoom_btn" :disabled="clickMapZoomStatus">+</button>
          <b></b>
          <button @click="clickMapZoom()" class="zoom_btn" :disabled="!clickMapZoomStatus">-</button>
        </div>

        <div v-if="!pageSize" class="statistics-area">
          <Statistics icon="img/nodemap/icon_1.png" :text="$t('node_map.HyperblockHight')" :value="hyperblockHight" type="#47b45d" />
          <Statistics icon="img/nodemap/icon_2.png" :text="$t('node_map.NodesNum')" :value="nodesNum" type="#fb745c" />
          <Statistics icon="img/nodemap/icon_3.png" :text="$t('node_map.Peak')" :value="`${peak} <span>/s</span>`" type="#3eb5c2" />
          <Statistics icon="img/nodemap/icon_4.png" :text="$t('node_map.TPS')" :value="`${tps} <span>/s</span>`" type="#9e6bed" />
          <Statistics icon="img/nodemap/icon_5.png" :text="$t('node_map.NextHyperblock')" :value="nextHyperblock" type="#5c82f0" />
        </div>

        <div v-if="pageSize" @click="mobileMovePage()" class="mobile-more_btn">{{$t('node_map.MoreBtnText')}}</div>

        <div id="map" class="map"></div>
      </div>
    </div>

    <ul v-if="pageSize" class="mobile-map_siderbar">
      <li>
        <div class="item">
          <span style="color: #ffb400;">{{node_LocalConsensus}}</span>
          <span>{{$t('node_map.LocalConsensus')}}</span>
        </div>
        <div class="item">
          <span style="color: #ffb400;">{{node_GlobalConsensus}}</span>
          <span>{{$t('node_map.GlobalConsensus')}}</span>
        </div>
      </li>
      <li>
        <div class="item">
          <span style="color: #5cd8b0;">{{node_Success}}</span>
          <span>{{$t('node_map.Success')}}</span>
        </div>
        <div class="item">
          <span style="color: #fb745c;">{{node_Exception}}</span>
          <span>{{$t('node_map.Exception')}}</span>
        </div>
      </li>
      <li>
        <div class="item">
          <span style="color: #ffb400;">{{node_Synchronizing}}</span>
          <span>{{$t('node_map.Synchronizing')}}</span>
        </div>
        <div class="item">
          <span style="color: #ffb400;">{{node_Idle}}</span>
          <span>{{$t('node_map.Idle')}}</span>
        </div>
      </li>
      <li>
        <div class="item">
          <span style="color: #bdbdbd;">{{node_Offline}}</span>
          <span>{{$t('node_map.OffLine')}}</span>
        </div>
        <div class="item">
          <span style="color: #fb745c;">{{node_Suspect}}</span>
          <span>{{$t('node_map.Suspect')}}</span>
        </div>
      </li>
    </ul>

    <ul v-if="pageSize" class="mobile-statistics">
      <li>
        <div class="item" style="background-color: #6ddd94;">
          <img src="img/nodemap/m_icon_1.png">
          <div class="mobile-statistics_value">{{hyperblockHight}}</div>
        </div>
        <div class="mobile-statistics_text">{{$t('node_map.HyperblockHight')}}</div>
      </li>
      <li>
        <div class="item" style="background-color: #fb745c;">
          <img src="img/nodemap/m_icon_2.png">
          <div class="mobile-statistics_value">{{nodesNum}}</div>
        </div>
        <div class="mobile-statistics_text">{{$t('node_map.NodesNum')}}</div>
      </li>
      <li>
        <div class="item" style="background-color: #7dd3db;">
          <img src="img/nodemap/m_icon_3.png">
          <div class="mobile-statistics_value">{{peak}}</div>
        </div>
        <div class="mobile-statistics_text">{{$t('node_map.Peak')}}</div>
      </li>
      <li>
        <div class="item" style="background-color: #9e6bed;">
          <img src="img/nodemap/m_icon_4.png">
          <div class="mobile-statistics_value">{{tps}}</div>
        </div>
        <div class="mobile-statistics_text">{{$t('node_map.TPS')}}</div>
      </li>
      <li>
        <div class="item" style="background-color: #5c82f0;">
          <img src="img/nodemap/m_icon_5.png">
          <div class="mobile-statistics_value">{{nextHyperblock}}</div>
        </div>
        <div class="mobile-statistics_text">{{$t('node_map.NextHyperblock')}}</div>
      </li>
    </ul>
  </div>
</template>

<script>
  import '@/assets/css/normalize.scss';
  import '@/assets/css/separate.scss';
  import '@/assets/css/common.scss';
  import '@/assets/css/nodes.scss';

  let base_url = process.env.VUE_APP_CURRENTMODE;

  import NodeStatus from '@/components/node_map/NodeStatus'
  import Statistics from '@/components/node_map/Statistics'

  export default {
    name: 'Node_map',
    components: {
      NodeStatus, Statistics
    },
    data() {
      return {
        lang: this.$i18n,
        pageSize: (document.body.clientWidth >= 769) ? false : true,

        map: '',
        map_AS: '', // 亚洲
        map_AS_node_num: 0,
        map_EU: '', // 欧洲
        map_EU_node_num: 0,
        map_OA: '', // 大洋洲
        map_OA_node_num: 0,
        map_NA: '', // 北美洲
        map_NA_node_num: 0,
        map_SA: '', // 南美洲
        map_SA_node_num: 0,

        nodeData: [],
        mapNodes: [], // 地图节点marker

        node_Offline: 0,
        node_Synchronizing: 0,
        node_Idle: 0,
        node_LocalConsensus: 0,
        node_GlobalConsensus: 0,
        node_Success: 0,
        node_Exception: 0,
        node_Suspect: 0,
        node_new: 0,

        clickMapZoomStatus: false, // + / - 按钮

        hyperblockHight: 0,
        nodesNum: 0,
        peak: 0,
        tps: 0,
        nextHyperblock: 0,
      }
    },
    created() {
      this.getInitData()
    },
    mounted() {
      // 初始化地图
      this.initMap();

      this.getPageSize();

      // 每2m更新数据
      setInterval(() => {
        this.getUpdateData();
      }, 20000);
    },
    watch: {
      nodeData() {
        // 初始化地图
        this.updateData()
      }
    },
    methods: {
      // 获取初始化数据
      getInitData() {
        this.$http({
          baseURL: base_url,
          url: '/hyperchain/nodeall',
          method: 'GET',
        }).then(res => {
          // console.log(res)

          // 节点数据
          this.nodeData = res.data.data.data;
          // 各大洲节点数
          this.map_AS_node_num = (typeof res.data.data.geo['AS'] == 'undefined') ? 0 : res.data.data.geo['AS'];
          this.map_EU_node_num = (typeof res.data.data.geo['EU'] == 'undefined') ? 0 : res.data.data.geo['EU'];
          this.map_OA_node_num = (typeof res.data.data.geo['OA'] == 'undefined') ? 0 : res.data.data.geo['OA'];
          this.map_NA_node_num = (typeof res.data.data.geo['NA'] == 'undefined') ? 0 : res.data.data.geo['NA'];
          this.map_SA_node_num = (typeof res.data.data.geo['SA'] == 'undefined') ? 0 : res.data.data.geo['SA'];

          // 各节点状态数量
          this.node_Offline = res.data.data.num.status0
          this.node_Synchronizing = res.data.data.num.status1
          this.node_Idle = res.data.data.num.status2
          this.node_LocalConsensus = res.data.data.num.status3
          this.node_GlobalConsensus = res.data.data.num.status4
          this.node_Success = res.data.data.num.status5
          this.node_Exception = res.data.data.num.status6
          this.node_Suspect = res.data.data.num.status7

          this.node_new = +res.data.data.new_num;
          this.hyperblockHight = res.data.data.global.chain_height
          this.nodesNum = res.data.data.global.online_node_num
          this.peak = res.data.data.global.tps_top
          this.tps = res.data.data.global.tps
          this.nextHyperblock = res.data.data.global.count_down

          this.nodesText();
        })
      },
      // 更新数据
      getUpdateData() {
        this.$http({
          baseURL: base_url,
          url: '/hyperchain/node',
          method: 'GET',
        }).then(res => {
          console.log(res)

          // 节点数据
          this.nodeData = res.data.data.data;
          // 各大洲节点数
          this.map_AS_node_num = (typeof res.data.data.geo['AS'] == 'undefined') ? 0 : res.data.data.geo['AS'];
          this.map_EU_node_num = (typeof res.data.data.geo['EU'] == 'undefined') ? 0 : res.data.data.geo['EU'];
          this.map_OA_node_num = (typeof res.data.data.geo['OA'] == 'undefined') ? 0 : res.data.data.geo['OA'];
          this.map_NA_node_num = (typeof res.data.data.geo['NA'] == 'undefined') ? 0 : res.data.data.geo['NA'];
          this.map_SA_node_num = (typeof res.data.data.geo['SA'] == 'undefined') ? 0 : res.data.data.geo['SA'];

          // 各节点状态数量
          this.node_Offline = res.data.data.num.status0
          this.node_Synchronizing = res.data.data.num.status1
          this.node_Idle = res.data.data.num.status2
          this.node_LocalConsensus = res.data.data.num.status3
          this.node_GlobalConsensus = res.data.data.num.status4
          this.node_Success = res.data.data.num.status5
          this.node_Exception = res.data.data.num.status6
          this.node_Suspect = res.data.data.num.status7

          this.node_new = +res.data.data.new_num;
          this.hyperblockHight = res.data.data.global.chain_height
          this.nodesNum = res.data.data.global.online_node_num
          this.peak = res.data.data.global.tps_top
          this.tps = res.data.data.global.tps
          this.nextHyperblock = res.data.data.global.count_down

          this.nodesText();
        })
      },
      // 初始地图
      initMap() {
        let p = sessionStorage.getItem('mapPostion') ? sessionStorage.getItem('mapPostion').split(',').map(Number) : null;
        // let centers = ((document.documentElement.clientWidth || document.body.clientWidth) >= 768) ? [58.878124,42.297113] : [104.117775,32.728926];
        
        let centers = p || [104.117775,32.728926];
        let zoom = +sessionStorage.getItem('mapZoom') || 3;

        this.map = new AMap.Map('map', {
          center: centers,
          // mapStyle: 'amap://styles/grey',
          preloadMode: true,
          zoom: zoom,
          zoomEnable: true,
          scrollWheel: false,
          doubleClickZoom: false,
          touchZoom: false,
          lang: 'zh_en',
        });

        if (zoom !== 5) {
          // 各州节点数显示
          this.createContinent()
          this.clickMapZoomStatus = false;
        }

        if (zoom !== 3) {
          // 各州节点数显示
          this.createNodes()
          this.clickMapZoomStatus = true;
        }
        
        // 地图事件初始化
        this.mapEvent();

      },
      updateData() {
        let getZoom = this.map.getZoom();
          this.clearContinent();
          this.clearNodes();

        if (getZoom === 3) {
          this.createContinent();
          this.clearNodes();
        } else if (getZoom === 5) {
          this.clearContinent();
          this.createNodes();
        }
      },
      // 地图事件
      mapEvent() {
        this.map.on('dblclick', e => {
          let position = [e.lnglat.getLng(), e.lnglat.getLat()];

          // this.clickMapZoomStatus = !this.clickMapZoomStatus

          this.setMapZoom(position);
        });

        // this.map.on('click', e => {
        //   let getZoom = this.map.getZoom();

        //   if (getZoom === 5) {
        //     // let nodes = document.querySelectorAll('.node')
        //     let node_tip = document.querySelectorAll('.node_tip');
        //     let node_info = document.querySelectorAll('.node_info');

        //     node_tip.forEach(item => {
        //       item.style.display = 'none';
        //     })
        //     // node_info.forEach(item => {
        //     //   item.style.display = 'none';
        //     // })
        //   }
        // });
      },
      // 各州节点总数事件 - 大圆
      continentEvent() {
        this.map_AS.on('click', e => {
          this.map.setCenter([116.397428, 39.90923]);
          this.setMapZoom()
        })
        this.map_EU.on('click', e => {
          this.map.setCenter([13.406062,52.496586]);
          this.setMapZoom()
        })
        this.map_OA.on('click', e => {
          this.map.setCenter([151.201166,-33.94621]);
          this.setMapZoom()
        })
        this.map_NA.on('click', e => {
          this.map.setCenter([-74.029003,40.800991]);
          this.setMapZoom()
        })
        this.map_SA.on('click', e => {
          this.map.setCenter([-58.591616,-34.639358]);
          this.setMapZoom()
        })
      },
      // 地图缩放
      setMapZoom(position) {
        let getZoom = this.map.getZoom();
        // console.log(center)

        this.clickMapZoomStatus = !this.clickMapZoomStatus

        if (position) {
          this.map.setCenter(position);
        }

        if (getZoom === 3) {
          let center = [this.map.getCenter().lng, this.map.getCenter().lat];
          sessionStorage.setItem('mapPostion', center)

          this.map.setZoom(5);
          this.clearContinent();
          this.createNodes();

          sessionStorage.setItem('mapZoom', 5)
        } else if (getZoom === 5) {
          this.map.setZoom(3);
          this.createContinent();
          this.clearNodes();

          sessionStorage.setItem('mapZoom', 3)
        }
      },
      // 创建各州节点总数 - 大圆
      createContinent() {
        // 亚洲
        this.map_AS = new AMap.Text({
          text: this.$t('node_map.NodesNum') + ': ' + this.map_AS_node_num,
          anchor: 'center',
          cursor: 'pointer',
          position: [104.468639, 38.973618],
        });
        this.map_AS.setMap(this.map);

        // 欧洲
        this.map_EU = new AMap.Text({
          text: this.$t('node_map.NodesNum') + ': ' + this.map_EU_node_num,
          anchor: 'center',
          cursor: 'pointer',
          position: [22.000000, 46.999203],
        });
        this.map_EU.setMap(this.map);

        // 大洋洲
        this.map_OA = new AMap.Text({
          text: this.$t('node_map.NodesNum') + ': ' + this.map_EU_node_num,
          anchor: 'center',
          cursor: 'pointer',
          position: [126.000000, -32.999203]
        });
        this.map_OA.setMap(this.map);

        // 北美洲
        this.map_NA = new AMap.Text({
          text: this.$t('node_map.NodesNum') + ': ' + this.map_NA_node_num,
          anchor: 'center',
          cursor: 'pointer',
          position: [618.000000, 36.999203]
        });

        this.map_NA.setMap(this.map);

        // 南美洲
        this.map_SA = new AMap.Text({
          text: this.$t('node_map.NodesNum') + ': ' + this.map_SA_node_num,
          anchor: 'center',
          cursor: 'pointer',
          position: [658.000000, -18.999203]
        });

        this.map_SA.setMap(this.map);

        // 各州节点数事件
        this.continentEvent();
      },
      // 清除各州节点总数 - 大圆
      clearContinent() {
        this.map.remove(this.map_AS);
        this.map.remove(this.map_EU);
        this.map.remove(this.map_OA);
        this.map.remove(this.map_NA);
        this.map.remove(this.map_SA);
      },
      createNodes() {
        let data = this.nodeData;
        let node;
        for (let i = 0, len = data.length; i < len; i++) {
          node = new AMap.Marker({
            position: new AMap.LngLat(data[i].pos.lng, data[i].pos.lat),
            content: `
              <div class="node status${data[i].status + 1}">
                <ul class="node_info" start="${data[i].new === 1 ? true : false}">
                  <li class="node_info-tip" style="${data[i].new === 1 ? '' : 'display: none'};">NEW</li>
                  <li class="node_info-ip">${data[i].name}</li>
                  <li class="node_info-text">${this.$t('node_map.' + data[i].text)}</li>
                </ul>
              </div>
            `,
            map: this.map
          });

          this.mapNodes.push(node)
        }
      },
      clearNodes() {
        this.mapNodes.forEach(item => {
          this.map.remove(item)
        });
      },
      clickMapZoom() {
        this.setMapZoom()
      },
      mobileMovePage() {
        let element = document.querySelector('.mobile-map_siderbar');
        let offsetTop = element.offsetTop
        console.log(offsetTop)
        document.scrollingElement.scrollTop = offsetTop
      },
      // 页面大小检测
      getPageSize() {
        // 监听窗口大小
        window.onresize = () => {
          return (() => {
            // this.screenWidth = document.body.clientWidth
            if (document.documentElement.clientWidth && document.body.clientWidth >= 769) {
              this.pageSize = false
            } else {
              this.pageSize = true
            }
          })()
        }
      },
      // 节点信息数据处理
      nodesText() {
        let data = this.nodeData;

        data.forEach(item => {
          switch (item.status) {
            case 0:
              item.text = 'OffLine';
              break;

            case 1:
              item.text = 'Synchronizing';
              break;

            case 2:
              item.text = 'Idle';
              break;

            case 3:
              item.text = 'LocalConsensus';
              break;

            case 4:
              item.text = 'GlobalConsensus';
              break;

            case 5:
              item.text = 'Success';
              break;

            case 6:
              item.text = 'Exception';
              break;

            case 7:
              item.text = 'Suspect';
              break;
          }
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  .nodeMap {
    margin-top: 60px;
    font-size: 16px;
  }

  .node_map_area {
    position: relative;
  }

  .map {
    width: 100%;
    height: calc(100vh - 60px);
  }

  @media (min-width: 769px) {
    .nodeMap {
      margin-top: 100px;
    }

    .map {
      height: calc(100vh - 100px);
    }
  }

  @media (min-width: 1200px) {
    .warpper {
      margin: 0 auto;
      width: 1200px;
    }
  }

  @media screen and (max-width: 1240px) {
    html, body {
      font-size: initial !important;
    }
  }
</style>

